<template>
  <div class="loading-container" :style="containerStyle">
    <div class="spinner" :style="spinnerStyle"></div>
    <p v-if="message" class="loading-message">{{ message }}</p>
  </div>
</template>
<script>
  export default {
    name: "LoadingSpinner",
    props: {
      message: {
        type: String,
        default: "",
      },
      size: {
        type: String,
        default: "40px",
      },
      color: {
        type: String,
        default: "#ec621a",
      },
      minHeight: {
        type: String,
        default: "200px",
      },
    },
    computed: {
      containerStyle() {
        return {
          minHeight: this.minHeight,
        };
      },
      spinnerStyle() {
        return {
          width: this.size,
          height: this.size,
          borderTopColor: this.color,
        };
      },
    },
  };
</script>

<style scoped>
  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
  }

  .spinner {
    border: 4px solid #f3f3f3;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .loading-message {
    margin: 0;
    color: #6c757d;
    font-size: 14px;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
